class Geocode {
  constructor() {}

  async getLocationByZip(code) {
    try {
      const { results } = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${code}&key=AIzaSyC3zZrAfOXA65w11uXB5yB5A200CLKozj8`).then((res) => res.json())

      const data = results?.[0]
      let city = null
      let country = null

      if (data) {
        country = data.address_components.find((address) => address.types.includes('country'))

        city = data.address_components.find((address) => address.types.includes('locality') || address.types.includes('administrative_area_level_3'))
        if (!city) {
          city = data.address_components.find((address) => address.types.includes('administrative_area_level_1'))
        }
      }

      return {
        city,
        country,
      }
    } catch (error) {
      console.log(error)
      return {
        city: null,
        country: null,
      }
    }
  }
}

export default Geocode
